module.exports = __webpack_public_path__ + "img/shengchan2.jpg";